module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-US"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ellen Datlow")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Noir is an attitude, a stance, a way of looking at the world. Paul Duncan, in his concise book "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Noir Fiction")]), _vm._v(", defines it as a term “used to describe any work, usually involving crime—that is notably dark, brooding, cynical, complex, and pessimistic.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Noir fiction has been popular since right after World War II and has maintained its popularity over the years. The world of noir is thick with criminality, rife with betrayal. But the main characters in noir are not necessarily detectives or criminals, hence the hard-living guy with a chip on his shoulder, a cold affect, and something painful (and tamped down) in his past, and the sexy dame with a middle name spelling “trouble” in capital letters.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The supernatural has taken a parallel path to the present but is an older form of literature, originally known as the gothic. There have been a lot of supernatural detective stories published, but relatively few supernatural noir stories. There "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("are ")]), _vm._v("a few detectives of the supernatural in this anthology, but they’re not very traditional, and they don’t always succeed in their quest for the truth—for the facts—and those who do are sometimes very sorry.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The noir form of fiction and film has been one of my favorites my whole life, as has supernatural fiction. So it seemed perfectly appropriate for me to edit an anthology of stories combining two of the genres of literature I love.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I asked for smart, edgy, complex, harder-than-nails stories of the supernatural with at least a few of the trademarks of noir. Some of the stories within feature women as the main characters, and at least one oddity only becomes a tale of detection quite late in the game. But whatever changes the evolution of mores and sensibilities have wrought on traditional noir, I think you’ll recognize the characteristics of noir and be entertained by these sixteen writers’ interpretations of the genre. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aec65b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/supernaturalepub.vue
// module id = 75
// module chunks = 0